import React from "react";
import Styled from "styled-components";
import { Box, Callout, FlexBox, FluidImage, Listbox, ListboxButton, ListboxList, ListboxOption, ListboxOptionTextContainer, ListboxOptionThumbnailContainer, ListboxPopover, useId, } from "@vp/swan";
import { OptionPriceDisplay } from "./../../../../shared/options-price-display";
import { encodeKey } from "../../helpers";
import { useListboxSelectionHelper } from "../../../../../hooks/use-listbox-selection-helper";
import { ListboxPlaceholder } from "./shared/listbox-placeholder";
import { useProductOptionsFeaturesContext } from "../../../../contexts/product-options-features";
import { SimpleTitle } from "../../../../shared/simple-title";
const ListboxSwanFixes = Styled.div `
.swan-listbox-button-with-label span>* {
  margin-left: unset;
}

.swan-listbox-button-with-label span {
  display: unset;
  align-items: unset;
}
`;
const Layout = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(ListboxSwanFixes, null, children);
};
export const StandardDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "none", hideImages, tenant, } = props;
    const titleId = useId();
    const hasImages = !hideImages && option.choices.some((c) => !!c.image);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    return (React.createElement(Layout, null,
        React.createElement(SimpleTitle, { titleId: titleId }),
        React.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange },
            React.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React.createElement(ListboxPlaceholder, null) }),
            React.createElement(ListboxPopover, null,
                React.createElement(ListboxList, null, option.choices
                    .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                    .map((choice) => {
                    const Label = () => (React.createElement(OptionLabel, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, fractionDigits: fractionDigits, currency: currency }));
                    return (React.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, label: React.createElement(FlexBox, { flexDirection: "row", gap: "3", fontWeight: "bold" },
                            React.createElement(Label, null)), withThumbnail: hasImages, disabled: choice.isOutOfStock },
                        hasImages && (React.createElement(ListboxOptionThumbnailContainer, null,
                            React.createElement(FluidImage, { src: choice.image }))),
                        React.createElement(FlexBox, { flexDirection: hasImages ? "column" : "row", alignItems: "center" },
                            React.createElement(Label, null),
                            !!choice.callouts &&
                                choice.callouts.length > 0 &&
                                choice.callouts.map((callout) => (React.createElement(Callout, { emphasis: "low", ml: "3", key: callout.key, skin: callout.style ?? "info" }, callout.text))))));
                }))))));
};
const OptionLabel = ({ tenant, choice, priceDisplayMode, locale, fractionDigits, currency, vatInc = false, hideVatMessage = true, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(ListboxOptionTextContainer, null, choice.name)),
        priceDisplayMode !== "none" && (React.createElement(Box, { ml: "2" },
            "(",
            React.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, vatInc: vatInc, hideVatMessage: hideVatMessage }),
            ")"))));
};
//# sourceMappingURL=standard-dropdown-skin.js.map